import { render } from "./ComponentPromise.vue?vue&type=template&id=e9e418c0"
import script from "./ComponentPromise.vue?vue&type=script&lang=js"
export * from "./ComponentPromise.vue?vue&type=script&lang=js"

import "./ComponentPromise.vue?vue&type=style&index=0&id=e9e418c0&lang=scss"

import exportComponent from "D:\\PhpstormProjects\\alignment-page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__